import { useEffect, useState } from "react";
import States from "../../../../utils/Constants"
import SuperSearchList from "../../../shared/SuperSearch/SuperSearchList"
import Table from "../../Shared/Table";
import { useSelector } from "react-redux";
import SuperSearchMultipleClient from "../../../shared/SuperSearch/MultipleSelection/SuperSearchMultipleClient";

const AssignedProfile = (props) => {
    let DropDowns = useSelector(state => state?.GeneralDropDownsReducer)

    const { FindByPracrice, practiceName, handlePracticeChange, handleSelectPractice, is, assignedPractices, columns
        , handleChangeAssignedProviders, AssignedProviders
        , handleChangeunAssignedProvider, unAssignedProviders
        , handleSwitchProviders
        , handleChangeAssignedLocation, AssignedLocations
        , handleChangeunAssignedLocation, unAssignedLocations
        , handleSwitchLocation
        , handleSaveAssignedProfiles
        , PracicesDropDown
        , handleSelectAllUnAssignedProviders, handleSelectAllUnAssignedLocation
        , isCheckedAllProviders, isCheckedAllLocations, selectedRows, onRowSelection, RolesData, UserRole, UserRoleid, handleChangeUserRole, handleSelectUserRole, UserValidationModal
        , additionalRoles, setAdditionalRoles, initialAdditionalRoles, setInitialAdditionalRoles, selectedPracticeID, activeTab, additionalRolesKey } = { ...props }
    // const onRowSelection = (listOfIds) => {
    //     const selectedRowsArray = Array.from(listOfIds);
    //     const lastitem = selectedRowsArray[selectedRowsArray.length - 1];
    //     setSelectedRows(new Set([lastitem]));
    //     FindByPracrice(lastitem)
    //     console.log(lastitem);
    // }

    return (

        <div className="h-100">

            <div className="h-100 position-relative">
                <div className="content-wrapper row m-0 alignitems-start">
                    <div className="col-md-6 ps-0 assign_practices_table ps-2">
                        <div className="hk-header-searchbar position-static m-0 d-block w-100">
                            <SuperSearchList
                                type="client"
                                id='State'
                                name='State'
                                searchValue={practiceName}
                                data={PracicesDropDown}
                                onChange={handlePracticeChange}
                                getSelectedData={handleSelectPractice}
                                is={is}
                                icon={true}
                                sup_btn='sup_btn-Inp'
                                sup_inp='superSearchVisitInp'
                                className='mt-0'
                                placeholder={"Assign Practice"}
                            />
                        </div>
                        {/* <div className="assign-profiles-content mt-2">
                            <p className="heading text-white ur_header">Assigned Practices</p>
                            <div className="ur-all-option-list d-flex flex-column ">
                                <div className="d-flex align-items-center justify-content-between w-100 option active">
                                    <div className="d-flex align-items-center gap-5">
                                        <p className="text">NorthWest Florida</p>
                                    </div>
                                    <i className="icon-delete text-danger fs-12"></i>
                                </div>
                                <div className="d-flex align-items-center justify-content-between w-100 option active">
                                    <div className="d-flex align-items-center gap-5">
                                        <p className="text">NorthWest Florida</p>
                                    </div>
                                    <i className="icon-delete text-danger fs-12"></i>
                                </div>
                                <div className="d-flex align-items-center justify-content-between w-100 option">
                                    <div className="d-flex align-items-center gap-5">
                                        <p className="text">NorthWest Florida</p>
                                    </div>
                                    <i className="icon-delete text-danger fs-12"></i>
                                </div>
                            </div>
                        </div> */}

                        <div className="practice-table overflow-visible h-100">
                            <div className="table-view SetupTable overflow-visible h-100">
                                <Table
                                    columns={columns}
                                    rows={assignedPractices}
                                    // height='500px'
                                    // rowClass={rowClass}
                                    dynamicClass="custom_checkboxes_gird_two diagnosis_grid fill-grid DataGrid-Table templates hk-exp-table"
                                    rowHeight={25}
                                    Key={612}
                                    Name={'AssignedProfiles'}
                                    hidePagination={true}
                                    selectedRows={selectedRows}
                                    onSelectedRowsChange={onRowSelection}
                                    hideColClass={'hide'}
                                />
                            </div>

                        </div>

                        {/* <div className="practice-table">
                            <table>
                                <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>Date</th>
                                        <th>Remove</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        [1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((item, index) => {
                                            return (
                                                <tr>
                                                    <td>Practice 1</td>
                                                    <td>12/12/2021</td>
                                                    <td>
                                                        <button className="btn btn-transparent">
                                                            <i className="icon-delete"></i>
                                                        </button>
                                                    </td>
                                                </tr>
                                            )
                                        })}
                                </tbody>
                            </table>
                        </div> */}
                    </div>
                    <div className="col-md-6 spacing_provider pe-0">
                        <div className="row justify-content-between">
                            <div className="w-45 px-0">
                                <div className="custom_check_box d-flex gap-2 ps-1">
                                    <input
                                        type="checkbox"
                                        className="form-check-input p-0"
                                        checked={isCheckedAllProviders}
                                        onChange={(e) => handleSelectAllUnAssignedProviders(e)}
                                        id={`unAssignedProviders`}
                                    />
                                    <p className="content-heading text-left">Providers</p>
                                </div>
                                <div className="checker-boxes">
                                    {unAssignedProviders.map((item, index) => {
                                        return (
                                            <div key={index} className="custom_check_box  form-check">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input p-0"
                                                    checked={item.isChecked}
                                                    onChange={() => handleChangeunAssignedProvider(index)}
                                                    id={`unAssignedProviders-${index}`}
                                                />
                                                <label className="form-check-label" htmlFor={`unAssignedProviders-${index}`}>
                                                    {item.ProviderName}
                                                </label>
                                            </div>
                                        );
                                    })}
                                    {unAssignedProviders?.length === 0 && <i className="text">Search Providers</i>}
                                </div>
                            </div>
                            <div className="w-10 px-0 swap-btn-col">
                                <button className="btn btn-transparent" onClick={handleSwitchProviders}>
                                    <i className="icon-Icon-material-swap-vert"></i>
                                </button>
                            </div>
                            <div className="w-45 px-0">
                                <p className="content-heading text-left">Assigned Providers</p>
                                <div className="checker-boxes">
                                    {AssignedProviders.map((item, index) => {
                                        return (
                                            <div key={index} className="form-check custom_check_box  ">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input p-0"
                                                    checked={item.isChecked}
                                                    onChange={() => handleChangeAssignedProviders(index)}
                                                    id={`AssignedProviders-${index}`}
                                                />
                                                <label className="form-check-label" htmlFor={`AssignedProviders-${index}`}>
                                                    {item.ProviderName}
                                                </label>
                                            </div>
                                        );
                                    })}
                                    {AssignedProviders?.length === 0 && <i className="text">No Provider(s) Assigned</i>}
                                </div>
                            </div>
                        </div>
                        <div className="row pe-1 mt-4">
                            <div className="w-45 px-0">
                                <div className="custom_check_box d-flex gap-2 ps-1">
                                    <input
                                        type="checkbox"
                                        className="form-check-input p-0"
                                        checked={isCheckedAllLocations}
                                        onChange={(e) => handleSelectAllUnAssignedLocation(e)}
                                        id={`unAssignedProviders`}
                                    />
                                    <p className="content-heading text-left">Locations</p>
                                </div>
                                <div className="checker-boxes">
                                    {
                                        unAssignedLocations && unAssignedLocations.map((item, index) => {
                                            return (
                                                <div key={index} className="form-check custom_check_box  ">
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input"
                                                        checked={item.isChecked}
                                                        onChange={() => handleChangeunAssignedLocation(index)}
                                                        id={`unAssignedLocations-${index}`}
                                                    />
                                                    <label className="form-check-label" htmlFor={`unAssignedLocations-${index}`}>
                                                        {item.LocationName}
                                                    </label>
                                                </div>
                                            )
                                        })
                                    }
                                    {unAssignedLocations?.length === 0 && <i className="text">Search Locations</i>}
                                </div>
                            </div>
                            <div className="w-10 px-0 swap-btn-col">
                                <button className="btn btn-transparent" onClick={handleSwitchLocation}>
                                    <i className="icon-Icon-material-swap-vert"></i>
                                </button>
                            </div>
                            <div className="w-45 px-0">
                                <p className="content-heading text-left">Assigned Locations</p>
                                <div className="checker-boxes">
                                    {
                                        AssignedLocations && AssignedLocations.map((item, index) => {
                                            return (
                                                <div key={index} className="form-check custom_check_box  ">
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input p-0"
                                                        checked={item.isChecked}
                                                        onChange={() => handleChangeAssignedLocation(index)}
                                                        id={`AssignedLocations-${index}`}
                                                    />
                                                    <label className="form-check-label" htmlFor={`AssignedLocations-${index}`}>
                                                        {item.LocationName}
                                                    </label>
                                                </div>
                                            )
                                        })
                                    }
                                    {AssignedLocations?.length === 0 && <i className="text">No Location(s) Assigned</i>}
                                </div>
                            </div>
                        </div>
                        <div className="row pe-1 mt-4 g-0 mx-0">
                            <div className="col-md-6 ps-0 pe-1-5">
                                <p className="content-heading text-left">Primary Role</p>
                                <div className={UserValidationModal.UserRoleVal ? 'form-group input error' : 'form-group'}>
                                    <SuperSearchList
                                        key={`${selectedPracticeID}-${props.activeTab}`}
                                        type="client"
                                        id='UserRole'
                                        name='UserRole'
                                        searchValue={UserRole}
                                        data={RolesData}
                                        onChange={handleChangeUserRole}
                                        getSelectedData={handleSelectUserRole}
                                        is={is}
                                        sup_btn='sup_btn-Inp'
                                        sup_inp='superSearchVisitInp'
                                        // filterWith="startsWith"
                                        // tableHeight="200px"
                                        // tableWidth="100%"
                                        inputError={UserValidationModal.UserRoleVal}
                                        ScrollOutside={true}
                                        icon='Simple'
                                    />
                                    {UserValidationModal.UserRoleVal}
                                </div>
                            </div>
                            <div className="col-md-6 pe-0 ps-1-5">
                                <p className="content-heading text-left">Additional Role(s)</p>
                                <div className={UserValidationModal.UserRoleVal ? 'form-group input error' : 'form-group'}>
                                    <SuperSearchMultipleClient
                                        key={`${props.additionalRolesKey}-${props.activeTab}`}
                                        id="AdditionalRole"
                                        name="AdditionalRole"
                                        selectedOptionsDisplay='Additional Role'
                                        initialSelectedValues={initialAdditionalRoles || []}
                                        searchParam={{ AdditionalRole: additionalRoles }}
                                        primaryRoleId={UserRoleid}
                                        setSearchParam={(value) => {
                                            if (value === null || value === undefined || value === '') {
                                                setAdditionalRoles('');
                                                setInitialAdditionalRoles([]);
                                            } else {
                                                const rolesValue = typeof value === 'object' ? value?.AdditionalRole : value;
                                                setAdditionalRoles(rolesValue || '');
                                            }
                                        }}
                                        options={RolesData?.filter(item => String(item.value) !== String(UserRoleid))}
                                        sup_btn="sup_btn-Inp"
                                        sup_inp="superSearchVisitInp"
                                        ScrollOutside={true}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>


                </div>
            </div>
        </div>
    )
}

export default AssignedProfile